import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addAgencyIndividual } from "common/services/individuals.service";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";
import IndividualForm from "pages/Individuals/IndividualForm";

const AddPayment: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchContracts: () => void;
  isLTA?: boolean;
}> = ({ toggle, isModalOpen, fetchContracts, isLTA }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      fullName: "",
      gender: "",
      passportOrIdNumber: "",
      emailAddress: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Please enter full name"),
      gender: Yup.string(),
      passportOrIdNumber: Yup.string(),
      emailAddress: Yup.string(),
      phoneNumber: Yup.string(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          fullName: values.fullName,
          gender: values?.gender || "Unknown",
          passportOrIdNumber: values?.passportOrIdNumber,
          emailAddress: values?.emailAddress,
          phoneNumber: values?.phoneNumber,
        },
      };
      // save new order
      setLoading(true);
      try {
        await addAgencyIndividual(data);
        fetchContracts();
        validation.resetForm();
        toggle();
        toast.success("Individual Added Successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("Individual Creation Failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Individual
      </ModalHeader>

      <IndividualForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default AddPayment;
